/**
 * @file smoothscroll.js
 *
 * https://github.com/iamdustan/smoothscroll
 */

import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();
